<template>
    <v-text-field
      v-model="phone"
      label="Telefoonnummer"
      :error="error"
      :error-messages="message"
      v-on:blur='handleBlur'
    >
    </v-text-field>
</template>

<script>
import { ParseError, parsePhoneNumber } from "libphonenumber-js";
import { mapState } from "vuex";
export default {
  props: {
    target: {
      type: String,
      default: undefined,
      required: true
    }
  },
  data() {
    return {
      phone: "",
      error: false,
      message: ""
    };
  },
  methods: {
    handleBlur() {
      try {
        const checkNumber = parsePhoneNumber(this.phone, "NL");
        if (!checkNumber.isValid()) {
          this.error = true;
          this.message = "Telefoonnummer is niet geldig";
        } else {
          this.error = false;
          this.message = "";
          if (this.$store.state.form[this.target] !== checkNumber.number) {
            this.$store.state.form[this.target] = checkNumber.number;
            this.$store.state.app.form.hasChange = true;
          }
        }
      } catch (error) {
        if (error instanceof ParseError) {
          this.error = true;
          this.message = "Telefoonnummer is niet geldig";
        } else {
          throw error;
        }
      }
    }
  },
  computed: {
    details() {
      return this.$store.state.form[this.target];
    }
  },

  watch: {
    phone() {
      try {
        const phoneNumber = parsePhoneNumber(this.phone, "NL");
        this.phone = phoneNumber.number;
      } catch (error) {}
    },
    details() {
      this.phone = this.$store.state.form[this.target];
      this.error = false;
      this.message = "";
    }
  },
  created() {
    if (this.$store.state.form[this.target] !== undefined) {
      this.phone = this.$store.state.form[this.target];
    }
  }
};
</script>
